import { render, staticRenderFns } from "./dev-box2.vue?vue&type=template&id=8e51c66c&scoped=true&"
import script from "./dev-box2.vue?vue&type=script&lang=js&"
export * from "./dev-box2.vue?vue&type=script&lang=js&"
import style0 from "./dev-box2.vue?vue&type=style&index=0&id=8e51c66c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e51c66c",
  null
  
)

export default component.exports